import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Doughnut } from 'react-chartjs-2';
import staticInformationService from '../../../services/Internal/Staff/dashboardInformation.service';

// Base palette is reused in order; if there are ever more slices than colors,
// additional colors are generated so the chart never runs out or repeats abruptly.
const BASE_COLORS = [
    '#6a4c93', '#d677b8', '#ff595e', '#ff924c', '#ffca3a', '#c5ca30', '#8ac926', '#52a675', '#1982c4', '#4267ac',
];

function getColorForIndex(index) {
    if (index < BASE_COLORS.length) {
        return BASE_COLORS[index];
    }
    const hue = (index * 47) % 360;
    return `hsl(${hue}, 55%, 50%)`;
}

function DashboardPendingInternalStatusCounts() {
    const [pendingCounts, setPendingCounts] = useState();
    const [hasLoaded, setHasLoaded] = useState(false);
    const pendingCountsConfig = {
        labels: [],
        options: {
            parsing: {
                key: 'count.total'
            },
            plugins: {
                legend: {
                    position: 'bottom'
                },
                title: {
                    display: true,
                    text: 'Pending Internal Statuses',
                    font: {
                        size: 20,
                        family: 'Arial',
                    },
                    //fullSize: true
                },
                tooltip: {
                    callbacks: {
                        title: function (tooltipItem) {
                            return tooltipItem[0].label;
                        },
                        label: function (tooltipItem) {
                            var dataIndex = tooltipItem.dataIndex;
                            var data = tooltipItem.dataset.data[dataIndex];
                            var tooltipStringArray = [];
                            tooltipStringArray.push(`Total: ${data.count.total}`);
                            tooltipStringArray.push(`Applications: ${data.count.applications}`);
                            tooltipStringArray.push(`Renewals: ${data.count.renewals}`);
                            tooltipStringArray.push(`Reinstatements: ${data.count.reinstatements}`);
                            return tooltipStringArray;
                        }
                    },
                    backgroundColor: '#000',
                    titleFontSize: 16,
                    titleFontColor: '#0066ff',
                    bodyFontColor: '#000',
                    bodyFontSize: 14,
                    displayColors: true
                },
                annotation: {
                    annotations: {
                        dLabel: {
                            type: 'doughnutLabel',
                            content: ({ chart }) =>
                                ['Total',
                                    chart.getDatasetMeta(0).total
                                ]
                            ,
                            font: [{ size: 40 }, { size: 30 }],
                            color: ['black', 'grey']
                        }
                    }
                },
                datalabels: {
                    formatter: function (value, context) {
                        return value.count.total;
                    },
                    font: {
                        size: 24,
                        weight: 'bold',
                        family: 'Arial',
                        style: 'normal',
                    },
                    color: 'white'
                },
            },
            maintainAspectRatio: false
        }
    }
    useEffect(() => {
        staticInformationService.getDashboardInternalStatusNumbers().then((response) => {
            // The API now returns one entry per internal status that currently has open
            // tasks, rather than a fixed set of buckets - so this just renders whatever
            // statuses come back and stays correct as statuses are added or soft-deleted.
            var statuses = response.data.filter((val) => val.totalCount > 0);

            var numbersData = statuses.map((val) => ({
                type: val.internalStatus,
                count: {
                    total: val.totalCount.toLocaleString("en-US"),
                    applications: val.applicationCount.toLocaleString("en-US"),
                    renewals: val.renewalCount.toLocaleString("en-US"),
                    reinstatements: val.reinstatementCount.toLocaleString("en-US")
                },
            }));

            pendingCountsConfig.labels = statuses.map((val) => val.internalStatus);

            setPendingCounts(
                {
                    labels: pendingCountsConfig.labels,
                    datasets: [{
                        label: 'Total',
                        data: numbersData,
                        datalabels: {
                            anchor: 'center'
                        },
                        backgroundColor: statuses.map((val, index) => getColorForIndex(index)),
                        borderWidth: 1
                    }
                    ]
                }
            );
            setHasLoaded(true);
        })
    }, [])
    ChartJS.register(
        ArcElement,
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        annotationPlugin
    );


    return (
        hasLoaded &&
        <Doughnut data={pendingCounts} options={pendingCountsConfig.options} plugins={[ChartDataLabels]} />
    )
}

export default DashboardPendingInternalStatusCounts;